import { render, staticRenderFns } from "./geolacationIcon.vue?vue&type=template&id=8f71dfec&scoped=true"
import script from "./geolacationIcon.vue?vue&type=script&lang=js"
export * from "./geolacationIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f71dfec",
  null
  
)

export default component.exports